import { useExperiment } from 'shared/experiment'

import { useDeusExMachina } from '~/domains/platform/infra/deus-ex-machina/hocs/with-deus-ex-machina'

import { useIsOneStone } from './use-is-one-stone'

export function useIsFeatureSettingsEnabled() {
  const isOneStone = useIsOneStone()
  const { deusExMachina } = useDeusExMachina()
  const subjectId = deusExMachina?.subject?.id ?? ''
  const { isFeatureFlagEnabled, ...rest } = useExperiment(subjectId, 'pjvc_digital_settings_enable_feature_web')

  return { isFeatureFlagEnabled: isFeatureFlagEnabled && isOneStone, ...rest }
}
